import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import {
  Alert,
  Box,
  Button,
  CssBaseline,
  Paper,
  Typography,
  useTheme,
} from '@mui/material'
import DesktopNav from '../components/desktop/DesktopNav'
import DesktopToolbar from '../components/desktop/DesktopToolbar'
import MobileTopNav, { MobileTopNavSpacer } from '../components/mobile/MobileTopNav'
import CrashPackageImportHistoryPanel from '../components/admin/crash-package-import-history-panel'
import { NAV_LAYOUT_MARGIN_START } from '../consts/nav-layout-margin'
import { getAccessTokenFromStorage } from '../offline/session-store'
import { canViewPackageImportsList } from '../offline/package-exports-permissions'

function readPersistedSession() {
  try {
    const raw = localStorage.getItem('adams_user')
    const u = raw ? JSON.parse(raw) : null
    return {
      token: u?.token || localStorage.getItem('token') || null,
      init: u?.init || {},
    }
  } catch {
    return {
      token: localStorage.getItem('token') || null,
      init: {},
    }
  }
}

export default function PackageImportsList({ position, isMobile }) {
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state || {}
  const persistedSession = useMemo(() => readPersistedSession(), [])
  const token = state?.token || persistedSession.token
  const init = state?.init || persistedSession.init || {}
  const userType = Number(init?.user?.type)
  const mayView = canViewPackageImportsList(userType)
  const toolbarHeight = theme.mixins.toolbar.minHeight
  const bearerToken = token || getAccessTokenFromStorage() || ''

  const accessDenied = (
    <Paper elevation={0} sx={{ p: 3, maxWidth: 560 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Trans>
          Import history is available only to organization administrators and
          multi-organization administrators.
        </Trans>
      </Alert>
      <Button
        variant="contained"
        onClick={() =>
          navigate('/home', { state: { ...state, token, init, isHistoryOpen: false } })
        }
      >
        <Trans>Back to home</Trans>
      </Button>
    </Paper>
  )

  return (
    <Box component="main" sx={{ height: isMobile ? 'auto' : `calc(100vh - ${toolbarHeight}px)` }}>
      <CssBaseline />
      {isMobile ? (
        <>
          <MobileTopNav token={token} user={init?.user} />
          <MobileTopNavSpacer />
        </>
      ) : (
        <>
          <DesktopNav position={position} subPanelElements={[]} />
          <DesktopToolbar />
        </>
      )}

      <Box
        sx={{
          ...(!isMobile && { marginInlineStart: NAV_LAYOUT_MARGIN_START }),
          p: { xs: 1, sm: 2 },
          overflow: 'auto',
        }}
      >
        {!mayView ? (
          accessDenied
        ) : (
          <CrashPackageImportHistoryPanel
            bearerToken={bearerToken}
            organizations={init?.organizations ?? []}
          />
        )}
      </Box>
    </Box>
  )
}
